import React, { useState, useEffect, useContext } from 'react';
import { CrudSkus } from '../../Components/Cruds/CrudSkus';
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters';
import { NotFoundPage } from '../NotFoundPage/NotFoundPage';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import { useLocation, Link } from 'react-router-dom';
import '../Skus/SkusPage.css';
import UserContext from '../../utils/Contexts/UserContext';

const moduleName = 'Skus';
export const SkusPage = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const user = useContext(UserContext);

  const getPermissions = async () => {
    setLoading(true);

    let permissions = {
      Consultar: false,
      Crear: false,
      Editar: false,
      Eliminar: false,
    };

    try {
      permissions = await getUserPermissionsByUserEmail(
        user.attributes['email'],
        user.attributes['custom:project'],
        moduleName
      );
      
      setUserPermissions(permissions);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
  }, []);

  return (
    <>
      {userPermissions && userPermissions['Consultar'] ? (
        <div
          style={{
            flex: '1 1 auto',
            display: 'flex',
            flexFlow: 'column',
            height: '100vh',
            overflowY: 'auto',
          }}
        >
          {location.state && location.state.nit !== '' ? (
            <div>
              <Link to="/providers" className="linkButton">
                &#8592; Volver
              </Link>
            </div>
          ) : null}
          <div
            style={{
              padding: '20px 5%',
              height: '100%',
            }}
          >
            <CrudSkus
              userName={user.attributes['family_name']}
              permissions={userPermissions}
              project={user.attributes['custom:project']}
              nit={location.state ? location.state.nit : ''}
            />
          </div>
        </div>
      ) : loading ? (
        <LoadingPage />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
};